import { NgModule } from '@angular/core';
import { OptionsCalculatorComponent } from './options-calculator/options-calculator.component';
import { ProbabilityCalculatorComponent } from './probability-calculator/probability-calculator.component';
import { FuturesCalculatorComponent } from './futures-calculator/futures-calculator.component';
import { CommonCalculatorComponent } from './common-calculator/common-calculator.component';
import { SharedModule } from '../shared/shared.module';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
import { CalculatorsService } from './calculators.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { TextMaskModule } from 'angular2-text-mask';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { AdvancedSearchModule } from 'app/advanced-search/advanced-search.module';
import { TuiInputModule } from '@taiga-ui/kit';
import { TuiHintModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { CommonCalculatorHeaderComponent } from './common-calculator/common-calculator-header/common-calculator-header.component';


@NgModule({
  declarations: [
    OptionsCalculatorComponent,
    ProbabilityCalculatorComponent,
    FuturesCalculatorComponent,
    CommonCalculatorComponent,
    CommonCalculatorHeaderComponent
  ],
  exports: [
    OptionsCalculatorComponent,
    FuturesCalculatorComponent,
    ProbabilityCalculatorComponent,
    CommonCalculatorComponent,
    CommonCalculatorHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DxAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    DxPopupModule,
    TextMaskModule,
    ClipboardModule,
    NgxSpinnerModule,
    AdvancedSearchModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiHintModule
  ],
  providers: [CalculatorsService]
})


export class CalculatorsModule {
}
